// extracted by css-extract-rspack-plugin
export default {"statsGridContent":"FlexSuiteStatistics-module__statsGridContent__VMK9a","statsGridItem":"FlexSuiteStatistics-module__statsGridItem__uY_9D"};